<template>
    <div id="app-container">
        <div class="App iframe-credit-card-payment-group">
            <div>
                <span class="SecurityEnvironmentIcon">
                    <i class="icon-lock"></i>
                    <span class="payment-environment-icon-text">Ambiente Seguro</span>
                </span>
                <div class="CardForm">
                    <div>
                        <div class="PaymentCardNumber input text required">
                            <label class="FormFieldLabel " for="creditCardpayment-card-0Number">Número do cartão</label>
                            <input id="creditCardpayment-card-0Number" class="input-medium  " name="cardNumber" type="tel" maxlength="30" v-model="paymentCreditCard.cardNumber" />
                        </div>
                        <div class="PaymentCardFlags clearfix form-inline">
                            <p class="card-flags active">
                                <label v-for="(cardFlag, index) in cardFlags" :key="index" v-bind:title="cardFlag.name" class="radio card-flag-label" v-bind:for="cardFlag.uicode">
                                    <input :key="index" class="card-flag-radio" v-bind:id="cardFlag.uicode" name="creditCardselectedCardFlag-0" tabindex="-1" type="radio" v-bind:value="cardFlag.id" v-model="activeCardFlagId"  />
                                    <span class="card-flag" v-bind:class="[cardFlag.name, cardFlag.id == activeCardFlagId ? 'card-selected' : '']"  >{{cardFlag.name}}</span>
                                </label>
                            </p>
                        </div>
                    </div>
                    <div class="PaymentInstallments ">
                        <p class="select required">
                            <label class="FormFieldLabel hide" for="creditCardpayment-card-0Brand">Parcelamentos disponíveis:</label>
                            <select class="input-xlarge " id="creditCardpayment-card-0Brand" v-model="paymentCreditCard.installment">
                                <option value="">Em quantas parcelas deseja pagar?</option>
                                <option v-for="(installment, index) in getInstallments" :key="index" v-bind:value="installment.number" >{{installment.description}}</option>
                            </select>
                        </p>
                    </div>
                    <div>
                        <p class="PaymentCardHolderName">
                            <label class="FormFieldLabel " for="creditCardpayment-card-0Name">Nome impresso no cartão</label>
                            <input class="input-medium  " id="creditCardpayment-card-0Name" name="ccName" type="text" v-model="paymentCreditCard.cardHolderName">
                        </p>
                        <div class="PaymentCardDueDate clearfix">
                            <label class="FormFieldLabel pull-left" for="creditCardpayment-card-0Month">Validade</label>
                            <p class="payment-card-due-month input text required">
                                <select class="input-mini " id="creditCardpayment-card-0Month" name="cardExpirationMonth" v-model="paymentCreditCard.month">
                                    <option value="">Mês</option>
                                    <option v-for="(month) in getMonths()" v-bind:value="month"  :key="month">{{month}}</option>
                                </select>
                            </p>
                            <p class="payment-card-lash">/</p>
                            <p class="payment-card-due-year input text required">
                                <select class="input-mini " id="creditCardpayment-card-0Year" name="cardExpirationYear" v-model="paymentCreditCard.year">
                                    <option value="">Ano</option>
                                    <option v-for="(year) in getYears()" v-bind:value="year" :key="year" >{{year}}</option>
                                </select>
                            </p>
                        </div>
                    </div>
                    <p class="PaymentCardCVV input text required">
                        <label class="FormFieldLabel " for="creditCardpayment-card-0Code">Código de segurança</label>
                        <input id="creditCardpayment-card-0Code" class="input-mini " maxlength="4" autocomplete="nope" type="tel" v-model="paymentCreditCard.cardCVV">
                    </p>
                    <p class="PaymentCardHolderDocument input text required mask">
                        <label class="FormFieldLabel " for="holder-document-0">CPF do titular</label>
                        <input id="holder-document-0" class="input-small  " type="tel" placeholder="999.999.999-99" v-model="paymentCreditCard.document">
                    </p>
                    <div class="BillingAddress BillingAddress-BRA clearfix">
                        <div>
                            <h5>Endereço de cobrança</h5>
                            <p class="payment-billing-address-country input one-delivery-country">País: BRA</p>
                            <div class="CountrySelector--all-countries">
                                <p class="payment-billing-address-country input text">
                                    <label class="FormFieldLabel " for="payment-billing-address-all-countries-0">País<span class="item-required">&nbsp;*</span></label>
                                    <select class="input-medium" id="payment-billing-address-all-countries-0" v-model="paymentCreditCard.addressCountry">
                                        <option></option>
                                        <option v-for="(country, index) in countries" :key="index" v-bind:value="country.code" >{{country.name}}</option>
                                    </select>
                                </p>
                            </div>
                            <div class="AddressForm">
                                <div class="PostalCode input text">
                                    <label class="FormFieldLabel " for="payment-billing-address-postalCode-0">CEP<span class="item-required">&nbsp;*</span></label>
                                    <input class="payment-billing-address-postalCode input-small " autocomplete="nope" id="payment-billing-address-postalCode-0" type="tel" v-model="paymentCreditCard.postalCode" v-on:keyup="searchCep" >
                                </div>
                                <p class="AddressField payment-billing-address-street input text ">
                                    <label class="FormFieldLabel " for="payment-billing-address-street-0">Endereço<span class="item-required">&nbsp;*</span></label>
                                    <input autocomplete="nope" class="payment-billing-address-street input-xlarge  " id="payment-billing-address-street-0" type="text" v-model="paymentCreditCard.addressStreet">
                                </p>
                                <p class="AddressField payment-billing-address-number input text ">
                                    <label class="FormFieldLabel " for="payment-billing-address-number-0">Número<span class="item-required">&nbsp;*</span></label>
                                    <input autocomplete="nope" class="payment-billing-address-number input-mini  " id="payment-billing-address-number-0" type="text" v-model="paymentCreditCard.addressNumber">
                                </p>
                                <p class="AddressField payment-billing-address-complement input text ">
                                    <label class="FormFieldLabel " for="payment-billing-address-complement-0">Complemento e referência</label>
                                    <input autocomplete="nope" class="payment-billing-address-complement input-large  " id="payment-billing-address-complement-0" type="text" placeholder="Opcional" v-model="paymentCreditCard.addressComplement">
                                </p>
                                <p class="AddressField payment-billing-address-neighborhood input text ">
                                    <label class="FormFieldLabel " for="payment-billing-address-neighborhood-0">Bairro<span class="item-required">&nbsp;*</span></label>
                                    <input autocomplete="nope" class="payment-billing-address-neighborhood input-large  " id="payment-billing-address-neighborhood-0" type="text" v-model="paymentCreditCard.addressNeighborhood">
                                </p>
                                <p class="AddressField payment-billing-address-city input text ">
                                    <label class="FormFieldLabel " for="payment-billing-address-city-0">Cidade<span class="item-required">&nbsp;*</span></label>
                                    <input autocomplete="nope" class="payment-billing-address-city input-large  " id="payment-billing-address-city-0" type="text" v-model="paymentCreditCard.addressCity">
                                </p>
                                <p class="AddressField payment-billing-address-state input text ">
                                    <label class="FormFieldLabel " for="payment-billing-address-state-0">Estado<span class="item-required">&nbsp;*</span></label>
                                    <select autocomplete="nope" class="payment-billing-address-state input-mini  " id="payment-billing-address-state-0" v-model="paymentCreditCard.addressState">
                                        <option value="">UF</option>
                                        <option v-for="(state, index) in states" :key="index" v-bind:value="state.code">{{state.name}}</option>
                                    </select>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <p style="display:none;" class="ChangeNumberOfPayments clearfix"><a href="javascript:void(0);">Pagar usando dois cartões</a></p>
            </div>
        </div>
    </div>

</template>

<style scoped src="@/assets/css/checkout-paymentcreditcard.module.css"></style>

<script>

	import { cepApi } from '@/services/api/cepApi.js'

    export default {
        name: 'payment-creditcard',
        data: () => ({
            paymentCreditCard: {
                cardNumber: '',
                activeCardFlagId: '1',
                installment: '',
                cardHolderName: '',
                cardCVV: '',
                document: '',
                postalCode: '',
                addressCountry: 'BRA',
                addressStreet: '',
                addressNeighborhood: '',
                addressNumber: '',
                addressCity: '',
                addressState: '',
                month: null,
                year: null
            },
            cardFlags: [
                { name: 'Visa', uicode: 'creditCardselectedCard0cc-0', id: 2 },
                { name: 'American Express', uicode: 'creditCardselectedCard1cc-0', id: 1 },
                { name: 'Diners', uicode: 'creditCardselectedCard2cc-0', id: 4 },
                { name: 'Mastercard', uicode: 'creditCardselectedCard3cc-0', id: 3 },
                { name: 'Elo', uicode: 'creditCardselectedCard4cc-0', id: 5 },
            ],
            activeCardFlagId: 2,
            installments: [
                { number: 1, description: 'Pagamento à vista', cardFlagId: 2 },
            ],
            countries: [
                { code: 'BRA', name: 'Brasil' }
            ],
            states: [
                { code: 'AC', name: 'AC' },
                { code: 'AL', name: 'AL' },
                { code: 'AM', name: 'AM' },
                { code: 'AP', name: 'AP' },
                { code: 'BA', name: 'BA' },
                { code: 'CE', name: 'CE' },
                { code: 'DF', name: 'DF' },
                { code: 'ES', name: 'ES' },
                { code: 'GO', name: 'GO' },
                { code: 'MA', name: 'MA' },
                { code: 'MT', name: 'MT' },
                { code: 'MS', name: 'MS' },
                { code: 'MG', name: 'MG' },
                { code: 'PA', name: 'PA' },
                { code: 'PB', name: 'PB' },
                { code: 'PR', name: 'PR' },
                { code: 'PE', name: 'PE' },
                { code: 'PI', name: 'PI' },
                { code: 'RJ', name: 'RJ' },
                { code: 'RN', name: 'RN' },
                { code: 'RO', name: 'RO' },
                { code: 'RS', name: 'RS' },
                { code: 'RR', name: 'RR' },
                { code: 'SC', name: 'SC' },
                { code: 'SE', name: 'SE' },
                { code: 'SP', name: 'SP' },
                { code: 'TO', name: 'TO' }
            ]
        }),
        mounted() {

        },
        computed: {
            getInstallments() {
                if (this.installments && this.installments.length) {
                    var a = [];
                    for (var i = 0; i < this.installments.length; i++) {
                        if (this.installments[i].cardFlagId == this.activeCardFlagId) a.push(this.installments[i]);
                    }
                    return a;
                }
                return [];
            }
        },
        methods: {
            getMonths() {
                var a = [];
                for (var i = 0; i < 12; i++) {
                    var n = (i + 1).toString();
                    if (n.length == 1) n = '0' + n;
                    a.push(n);
                }
                return a;
            },
            getYears() {
                var a = [];
                var iy = new Date().getFullYear() - 2000;
                for (var i = 0; i < 40; i++) {
                    var n = (i + iy).toString();
                    a.push(n);
                }
                return a;
            },
            searchCep() {
                var self = this;
                if (self.paymentCreditCard.postalCode.length >= 8) {
                    cepApi.getAddress({ cep: self.paymentCreditCard.postalCode })
                        .then(function (data) {
                            self.paymentCreditCard.addressStreet = data.logradouro;
                            self.paymentCreditCard.addressCity = data.localidade;
                            self.paymentCreditCard.addressState = data.uf;
                            self.paymentCreditCard.addressNeighborhood = data.bairro;
                        });
                }
            }			
        }
    }
</script>


<!--
            countries: [
                { code: 'AFG', name: 'Afeganistão' },
                { code: 'ZAF', name: 'África do Sul' },
                { code: 'ALA', name: 'Åland, Ilhas' },
                { code: 'ALB', name: 'Albânia' },
                { code: 'DEU', name: 'Alemanha' },
                { code: 'AND', name: 'Andorra' },
                { code: 'AGO', name: 'Angola' },
                { code: 'AIA', name: 'Anguilla' },
                { code: 'ATG', name: 'Antígua e Barbuda' },
                { code: 'SAU', name: 'Arábia Saudita' },
                { code: 'DZA', name: 'Argélia' },
                { code: 'ARG', name: 'Argentina' },
                { code: 'ARM', name: 'Armênia' },
                { code: 'ABW', name: 'Aruba' },
                { code: 'AUS', name: 'Austrália' },
                { code: 'AUT', name: 'Áustria' },
                { code: 'AZE', name: 'Azerbaijão' },
                { code: 'BHS', name: 'Bahamas' },
                { code: 'BHR', name: 'Bahrain' },
                { code: 'BGD', name: 'Bangladesh' },
                { code: 'BRB', name: 'Barbados' },
                { code: 'BEL', name: 'Bélgica' },
                { code: 'BLZ', name: 'Belize' },
                { code: 'BEN', name: 'Benim' },
                { code: 'BMU', name: 'Bermudas' },
                { code: 'BLR', name: 'Bielorrússia' },
                { code: 'BOL', name: 'Bolívia' },
                { code: 'BES', name: 'Bonaire, Santo Eustáquio e Saba' },
                { code: 'BIH', name: 'Bósnia e Herzegovina' },
                { code: 'BWA', name: 'Botswana' },
                { code: 'BRA', name: 'Brasil' },
                { code: 'BRN', name: 'Brunei' },
                { code: 'BGR', name: 'Bulgária' },
                { code: 'BFA', name: 'Burkina Faso' },
                { code: 'BDI', name: 'Burundi' },
                { code: 'BTN', name: 'Butão' },
                { code: 'CPV', name: 'Cabo Verde' },
                { code: 'CMR', name: 'Camarões' },
                { code: 'KHM', name: 'Cambodja' },
                { code: 'CAN', name: 'Canadá' },
                { code: 'CYM', name: 'Cayman, Ilhas' },
                { code: 'KAZ', name: 'Cazaquistão' },
                { code: 'CAF', name: 'Centro-Africana, República' },
                { code: 'TCD', name: 'Chade' },
                { code: 'CZE', name: 'Checa, República' },
                { code: 'CHL', name: 'Chile' },
                { code: 'CHN', name: 'China' },
                { code: 'CYP', name: 'Chipre' },
                { code: 'CXR', name: 'Christmas, Ilha' },
                { code: 'CCK', name: 'Cocos, Ilhas' },
                { code: 'COL', name: 'Colômbia' },
                { code: 'COM', name: 'Comores' },
                { code: 'COD', name: 'Congo, República Democrática do&nbsp;(antigo&nbsp;Zaire)' },
                { code: 'COG', name: 'Congo, República do' },
                { code: 'COK', name: 'Cook, Ilhas' },
                { code: 'KOR', name: 'Coreia do Sul' },
                { code: 'PRK', name: 'Coreia, República Democrática da&nbsp;(Coreia do Norte)' },
                { code: 'CIV', name: 'Costa do Marfim' },
                { code: 'CRI', name: 'Costa Rica' },
                { code: 'HRV', name: 'Croácia' },
                { code: 'CUB', name: 'Cuba' },
                { code: 'CUW', name: 'Curaçao' },
                { code: 'DNK', name: 'Dinamarca' },
                { code: 'DJI', name: 'Djibouti' },
                { code: 'DMA', name: 'Dominica' },
                { code: 'DOM', name: 'Dominicana, República' },
                { code: 'EGY', name: 'Egito' },
                { code: 'SLV', name: 'El Salvador' },
                { code: 'ARE', name: 'Emirados Árabes Unidos' },
                { code: 'ECU', name: 'Equador' },
                { code: 'ERI', name: 'Eritreia' },
                { code: 'SVK', name: 'Eslováquia' },
                { code: 'SVN', name: 'Eslovênia' },
                { code: 'ESP', name: 'Espanha' },
                { code: 'USA', name: 'Estados Unidos' },
                { code: 'EST', name: 'Estónia' },
                { code: 'ETH', name: 'Etiópia' },
                { code: 'FRO', name: 'Feroé, Ilhas' },
                { code: 'FJI', name: 'Fiji' },
                { code: 'PHL', name: 'Filipinas' },
                { code: 'FIN', name: 'Finlândia' },
                { code: 'FRA', name: 'França' },
                { code: 'GAB', name: 'Gabão' },
                { code: 'GMB', name: 'Gâmbia' },
                { code: 'GHA', name: 'Gana' },
                { code: 'GEO', name: 'Geórgia' },
                { code: 'GIB', name: 'Gibraltar' },
                { code: 'GRC', name: 'Grécia' },
                { code: 'GRD', name: 'Grenada' },
                { code: 'GRL', name: 'Groenlândia' },
                { code: 'GLP', name: 'Guadalupe' },
                { code: 'GUM', name: 'Guam' },
                { code: 'GTM', name: 'Guatemala' },
                { code: 'GGY', name: 'Guernsey' },
                { code: 'GUY', name: 'Guiana' },
                { code: 'GUF', name: 'Guiana Francesa' },
                { code: 'GNQ', name: 'Guiné Equatorial' },
                { code: 'GNB', name: 'Guiné-Bissau' },
                { code: 'GIN', name: 'Guiné-Conacri' },
                { code: 'HTI', name: 'Haiti' },
                { code: 'HND', name: 'Honduras' },
                { code: 'HKG', name: 'Hong Kong' },
                { code: 'HUN', name: 'Hungria' },
                { code: 'YEM', name: 'Iémen' },
                { code: 'IND', name: 'Índia' },
                { code: 'IDN', name: 'Indonésia' },
                { code: 'IRN', name: 'Irã' },
                { code: 'IRQ', name: 'Iraque' },
                { code: 'IRL', name: 'Irlanda' },
                { code: 'ISL', name: 'Islândia' },
                { code: 'ISR', name: 'Israel' },
                { code: 'ITA', name: 'Itália' },
                { code: 'JAM', name: 'Jamaica' },
                { code: 'JPN', name: 'Japão' },
                { code: 'JEY', name: 'Jersey' },
                { code: 'JOR', name: 'Jordânia' },
                { code: 'KIR', name: 'Kiribati' },
                { code: 'KWT', name: 'Kuwait' },
                { code: 'LAO', name: 'Laos' },
                { code: 'LSO', name: 'Lesoto' },
                { code: 'LVA', name: 'Letônia' },
                { code: 'LBN', name: 'Líbano' },
                { code: 'LBR', name: 'Libéria' },
                { code: 'LBY', name: 'Líbia' },
                { code: 'LIE', name: 'Liechtenstein' },
                { code: 'LTU', name: 'Lituânia' },
                { code: 'LUX', name: 'Luxemburgo' },
                { code: 'MAC', name: 'Macau' },
                { code: 'MKD', name: 'Macedônia, República da' },
                { code: 'MDG', name: 'Madagáscar' },
                { code: 'MYS', name: 'Malásia' },
                { code: 'MWI', name: 'Malawi' },
                { code: 'MDV', name: 'Maldivas' },
                { code: 'MLI', name: 'Mali' },
                { code: 'MLT', name: 'Malta' },
                { code: 'FLK', name: 'Malvinas, Ilhas&nbsp;(Falkland)' },
                { code: 'IMN', name: 'Man, Ilha de' },
                { code: 'MNP', name: 'Marianas Setentrionais' },
                { code: 'MAR', name: 'Marrocos' },
                { code: 'MHL', name: 'Marshall, Ilhas' },
                { code: 'MTQ', name: 'Martinica' },
                { code: 'MUS', name: 'Maurícia' },
                { code: 'MRT', name: 'Mauritânia' },
                { code: 'MYT', name: 'Mayotte' },
                { code: 'MEX', name: 'México' },
                { code: 'FSM', name: 'Micronésia, Estados Federados da' },
                { code: 'MOZ', name: 'Moçambique' },
                { code: 'MDA', name: 'Moldávia' },
                { code: 'MCO', name: 'Mônaco' },
                { code: 'MNG', name: 'Mongólia' },
                { code: 'MNE', name: 'Montenegro' },
                { code: 'MSR', name: 'Montserrat' },
                { code: 'MMR', name: 'Myanmar&nbsp;(antiga&nbsp;Birmânia)' },
                { code: 'NAM', name: 'Namíbia' },
                { code: 'NRU', name: 'Nauru' },
                { code: 'NPL', name: 'Nepal' },
                { code: 'NIC', name: 'Nicarágua' },
                { code: 'NER', name: 'Níger' },
                { code: 'NGA', name: 'Nigéria' },
                { code: 'NIU', name: 'Niue' },
                { code: 'NFK', name: 'Norfolk, Ilha' },
                { code: 'NOR', name: 'Noruega' },
                { code: 'NCL', name: 'Nova Caledônia' },
                { code: 'NZL', name: 'Nova Zelândia&nbsp;(Aotearoa)' },
                { code: 'OMN', name: 'Oman' },
                { code: 'NLD', name: 'Países Baixos&nbsp;(Holanda)' },
                { code: 'PLW', name: 'Palau' },
                { code: 'PSE', name: 'Palestina' },
                { code: 'PAN', name: 'Panamá' },
                { code: 'PNG', name: 'Papua-Nova Guiné' },
                { code: 'PAK', name: 'Paquistão' },
                { code: 'PRY', name: 'Paraguai' },
                { code: 'PER', name: 'Peru' },
                { code: 'PCN', name: 'Pitcairn' },
                { code: 'PYF', name: 'Polinésia Francesa' },
                { code: 'POL', name: 'Polônia' },
                { code: 'PRI', name: 'Porto Rico' },
                { code: 'PRT', name: 'Portugal' },
                { code: 'QAT', name: 'Qatar' },
                { code: 'KEN', name: 'Quênia' },
                { code: 'KGZ', name: 'Quirguistão' },
                { code: 'GBR', name: 'Reino Unido da Grã-Bretanha e Irlanda do Norte' },
                { code: 'REU', name: 'Reunião' },
                { code: 'ROU', name: 'Romênia' },
                { code: 'RWA', name: 'Ruanda' },
                { code: 'RUS', name: 'Rússia' },
                { code: 'ESH', name: 'Saara Ocidental' },
                { code: 'SPM', name: 'Saint Pierre et Miquelon' },
                { code: 'SLB', name: 'Salomão, Ilhas' },
                { code: 'WSM', name: 'Samoa&nbsp;(Samoa Ocidental)' },
                { code: 'ASM', name: 'Samoa Americana' },
                { code: 'SMR', name: 'San Marino' },
                { code: 'SHN', name: 'Santa Helena' },
                { code: 'LCA', name: 'Santa Lúcia' },
                { code: 'BLM', name: 'São Bartolomeu' },
                { code: 'KNA', name: 'São Cristóvão e Névis&nbsp;(Saint Kitts e Nevis)' },
                { code: 'MAF', name: 'São Martinho' },
                { code: 'SXM', name: 'São Martinho (Países Baixos)' },
                { code: 'STP', name: 'São Tomé e Príncipe' },
                { code: 'VCT', name: 'São Vicente e Granadinas' },
                { code: 'SEN', name: 'Senegal' },
                { code: 'SLE', name: 'Serra Leoa' },
                { code: 'SRB', name: 'Sérvia' },
                { code: 'SYC', name: 'Seychelles' },
                { code: 'SGP', name: 'Singapura' },
                { code: 'SYR', name: 'Síria' },
                { code: 'SOM', name: 'Somália' },
                { code: 'LKA', name: 'Sri Lanka' },
                { code: 'SWZ', name: 'Suazilândia' },
                { code: 'SDN', name: 'Sudão' },
                { code: 'SSD', name: 'Sudão do Sul' },
                { code: 'SWE', name: 'Suécia' },
                { code: 'CHE', name: 'Suíça' },
                { code: 'SUR', name: 'Suriname' },
                { code: 'SJM', name: 'Svalbard&nbsp;e&nbsp;Jan Mayen' },
                { code: 'THA', name: 'Tailândia' },
                { code: 'TWN', name: 'Taiwan' },
                { code: 'TJK', name: 'Tajiquistão' },
                { code: 'TZA', name: 'Tanzânia' },
                { code: 'TLS', name: 'Timor-Leste' },
                { code: 'TGO', name: 'Togo' },
                { code: 'TON', name: 'Tonga' },
                { code: 'TKL', name: 'Toquelau' },
                { code: 'TTO', name: 'Trindade e Tobago' },
                { code: 'TUN', name: 'Tunísia' },
                { code: 'TCA', name: 'Turks e Caicos' },
                { code: 'TKM', name: 'Turquemenistão' },
                { code: 'TUR', name: 'Turquia' },
                { code: 'TUV', name: 'Tuvalu' },
                { code: 'UKR', name: 'Ucrânia' },
                { code: 'UGA', name: 'Uganda' },
                { code: 'URY', name: 'Uruguai' },
                { code: 'UZB', name: 'Usbequistão' },
                { code: 'VUT', name: 'Vanuatu' },
                { code: 'VAT', name: 'Vaticano' },
                { code: 'VEN', name: 'Venezuela' },
                { code: 'VNM', name: 'Vietnam' },
                { code: 'VIR', name: 'Virgens Americanas, Ilhas' },
                { code: 'VGB', name: 'Virgens Britânicas, Ilhas' },
                { code: 'WLF', name: 'Wallis e Futuna' },
                { code: 'ZMB', name: 'Zâmbia' },
                { code: 'ZWE', name: 'Zimbabwe' }
            ]
-->
